import { useRef, useEffect } from 'react'
import { useFeatureFlags } from 'app/utils/feature-flags'

export const types = {
  standard: 'track',
  custom: 'trackCustom'
}

export const standardEvents = {
  contact: 'Contact',
  lead: 'Lead'
}

export default function useMetaEventTracker({functionName = types.standard} = {}) {
  const ref = useRef()
  const [featureFlags] = useFeatureFlags()

  const featureFlagEntries = Object.entries(featureFlags)

  useEffect(() => {
    ref.current = window.fbq
  }, [])

  return {
    event(eventName, params) {
      if (!ref.current) {
        return null
      }

      if (featureFlagEntries.length) {
        params = {
          ...params,
          feature_flags: featureFlagEntries.filter(f => f[1]).map(f => f[0]).join(',')
        }
      }
      
      return ref.current(functionName, eventName, params)
    }
  }
}
